import type { ICalculatorState } from "../types/state.types.ts"

export class CalculatorStateClass implements ICalculatorState {
    isProcessed = false
    isFailed = false
    data = null
    inputData = null
    manualEligibilityData = null
}
